module.exports = __webpack_public_path__ + "img/Guinea-Bissau.f337e3f3.gif";